// extracted by mini-css-extract-plugin
module.exports = {"heading":"articles_heading__2NuNR","content":"articles_content__JYtTe","button":"articles_button__2qwfR","sending":"articles_sending__27sMh"};